import { ref, onUnmounted } from 'vue'

export type ResizeDirection = 'horizontal' | 'vertical'

export function useResize(
  direction: ResizeDirection,
  onResize: (delta: number) => void,
) {
  const dragging = ref(false)
  let startPos = 0

  function onPointerDown(e: PointerEvent) {
    e.preventDefault()
    dragging.value = true
    startPos = direction === 'horizontal' ? e.clientX : e.clientY
    document.body.style.cursor = direction === 'horizontal' ? 'col-resize' : 'row-resize'
    document.body.style.userSelect = 'none'
    document.addEventListener('pointermove', onPointerMove)
    document.addEventListener('pointerup', onPointerUp)
  }

  function onPointerMove(e: PointerEvent) {
    const current = direction === 'horizontal' ? e.clientX : e.clientY
    const delta = current - startPos
    startPos = current
    onResize(delta)
  }

  function onPointerUp() {
    dragging.value = false
    document.body.style.cursor = ''
    document.body.style.userSelect = ''
    document.removeEventListener('pointermove', onPointerMove)
    document.removeEventListener('pointerup', onPointerUp)
  }

  onUnmounted(() => {
    document.removeEventListener('pointermove', onPointerMove)
    document.removeEventListener('pointerup', onPointerUp)
  })

  return { dragging, onPointerDown }
}
